
import React, { useState, useEffect, useRef } from "react";
import "./Proofreading.css";
import axios from 'axios';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import EditDocumentIcon from '@mui/icons-material/EditDocument'
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import DeleteIcon from '@mui/icons-material/Delete';
import { CircularProgress } from '@mui/material';

const Proofreading = () => {
  const fileInputRefs = useRef({});

  const API_BASE = "https://api.waraq.co/waraq/api/v1";
  const [requeestID, setRequeestID] = useState(null)
  const [data, setData] = useState([])
  const [openRequests, setOpenRequests] = useState({});
  const [currentOpenRequestId, setCurrentOpenRequestId] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState({});
  const [errorMessage, setErrorMessage] = useState(null)
  const [successfulMessage, setSuccessfulMessage] = useState('')
  const [uploadMessage, setUploadMessage] = useState(null);
  const [uploadingRows, setUploadingRows] = useState({});
  const [uploadMistakes, setUploadMistakes] = useState({})
  const fileInputRef = useRef(null);

  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedDocId, setSelectedDocId] = useState(null)
  const [showPopup, setShowPopup] = useState(false);

  const getAuthHeaders = () => {
    const token = localStorage.getItem("jwtToken");
    return { Authorization: `${token}` };
  };

  const handleStatusChange = async () => {
    try {
      const res = await axios.patch(
        `${API_BASE}/translate/requests/${requeestID}/status?status=STAMPING`,
        {},
        { headers: getAuthHeaders() }
      );
      setSuccessfulMessage('Status changed successful To STAMPING');
      setShowPopup(false);
      await getProofreadingData();
    } catch (error) {
      let apiErrors = {};
      if (error.response) {
        apiErrors.password = error.response.data.data
        console.log('error assing ', error.response.data.data);
        setErrorMessage(error.response.data.data)
        setShowPopup(false);
        setTimeout(() => {
          setErrorMessage(null);
        }, 3000);
      }
    }
  };

  const handleNextClick = () => {
    setShowPopup(true);
  };

  const handleCancel = () => {
    setShowPopup(false);
  };

  const handleIconClick = (rowId) => {
    if (fileInputRefs.current[rowId]) {
      fileInputRefs.current[rowId].click();
    }
  };

  const getProofreadingData = async () => {
    try {
      const res = await axios.get(`https://api.waraq.co/waraq/api/v1/user/translate/requests/proofreading`, { headers: getAuthHeaders() });
      console.log('getProofreadingData', res?.data?.data);
      setData(res.data.data);
    } catch (err) {
      console.log('Proofreading', err);
    }
  }

  const handleDownload = async (mediaId, name) => {
    try {

      console.log('mediaId', mediaId);
      console.log('name ', name);

      let splitFileName = name.split('.com/')[1];
      const url = `${API_BASE}/media/download/${mediaId}`;
      const response = await axios.get(url, {
        headers: getAuthHeaders(),
        responseType: "blob",
      });

      const blob = response.data;
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;

      const contentDisposition = response.headers["content-disposition"];
      let fileName = splitFileName
      if (contentDisposition) {
        const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (match?.[1]) {
          fileName = match[1].replace(/['"]/g, "");
        }
      }

      if (!fileName.includes(".")) {
        const contentType = response.headers["content-type"];
        const ext = contentType?.split("/")[1] || "bin";
        fileName = `${fileName}.${ext}`;
      }

      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  const handleUploadMisTakes = async (e, id) => {
    try {
      const file = e.target.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append("file", file);
      await axios.patch(
        `${API_BASE}/translate/requests/${id}/mistakes-document`,
        formData,
        {
          headers: {
            ...getAuthHeaders(),
            'Content-Type': 'multipart/form-data'
          }
        }
      );

      setUploadMessage('Mistakes Document uploaded successfully');
      await getProofreadingData();

      setTimeout(() => {
        setUploadMessage(null);
      }, 3000);

    } catch (err) {
      console.error(
        "Error when uploading template:",
        err?.response?.data?.data || err.message
      );
    } finally {
      setUploadMistakes((prev) => ({ ...prev, [id]: false }));
    }
  };

  const deleteMistakesDocs = async(id)=>{
    try{
      await axios.delete(
        `${API_BASE}/translate/requests/${id}/mistakes-document`,
        {
          headers: getAuthHeaders(),
        }
      );
      await getProofreadingData();
    }catch(err){

    }
  }

  const handleFileChange = async (event, rowId) => {
    const file = event.target.files?.[0];
    if (!file) return;

    try {
      setUploadingRows((prev) => ({ ...prev, [rowId]: true }));
      setSelectedFiles((prev) => ({
        ...prev,
        [rowId]: file,
      }));

      const formData = new FormData();
      formData.append("file", file);

      await axios.patch(
        `${API_BASE}/translate/docs/${rowId}/translated-document`,
        formData,
        {
          headers: getAuthHeaders(),
        }
      );

      setUploadMessage('Document uploaded successfully');
      // Pass false to update without closing
      await getDocByRequestID(currentOpenRequestId, false);
      setTimeout(() => {
        setUploadMessage(null);
      }, 3000);

    } catch (err) {
      console.error(
        "Error when uploading template:",
        err?.response?.data?.data || err.message
      );
    } finally {
      setUploadingRows((prev) => ({ ...prev, [rowId]: false }));
      // Clear the file input so the same file can be uploaded again
      if (fileInputRefs.current[rowId]) {
        fileInputRefs.current[rowId].value = '';
      }
    }
  };

  const getDocByRequestID = async (id, shouldToggle = true) => {
    setRequeestID(id)
    try {
      const res = await axios.get(
        `${API_BASE}/translate/docs?requestId=${id}`,
        { headers: getAuthHeaders() }
      );

      const mappedDocs = res.data.data.map((doc) => ({
        id: doc.id,
        document: doc.documentUrl,
        documentId: doc.documentId,
        finalTranslatedDocumentId: doc.finalTranslatedDocumentId,
        finalTranslatedDocumentUrl: doc.finalTranslatedDocumentUrl,
        templateUrl: doc.templateUrl,
        templateId: doc.templateId,
        translatedDocumentId: doc.translatedDocumentId,
        translatedDocumentUrl: doc.translatedDocumentUrl,
        creationDate: doc.creationDate,
      }));

      // Update the documents data
      setOpenRequests((prev) => ({
        ...prev,
        [id]: mappedDocs,
      }));

      // Only toggle open/close if shouldToggle is true
      if (shouldToggle) {
        setCurrentOpenRequestId((prevId) => 
          prevId === id ? null : id
        );
      }

    } catch (err) {
      console.error("Error when get doc by request ID", err);
    }
  };

  const renderConfirmationPopup = () => {
    if (!showPopup) return null;

    return (
      <div style={styles.popupOverlay}>
        <div style={styles.popupContent}>
          <h3 style={styles.popupTitle}>
            Are you sure you want to change status to Stamping?
          </h3>
          <div style={styles.popupButtons}>
            <button onClick={handleCancel} style={styles.cancelButton}>
              Cancel
            </button>
            <button onClick={handleStatusChange} style={styles.confirmButton}>
              Confirm
            </button>
          </div>
        </div>
      </div>
    );
  };

  const DeleteTranslation = async (id) => {
    try {
      await axios.delete(
        `${API_BASE}/translate/docs/${id}/translated-document`,
        { headers: getAuthHeaders() }
      );
      // Pass false to update without closing
      await getDocByRequestID(currentOpenRequestId, false);
      setShowDeletePopup(false);
      
      // Clear the file input after delete
      if (fileInputRefs.current[id]) {
        fileInputRefs.current[id].value = '';
      }
    } catch (err) {
      console.log('error when delete', err.response.data.data);
    }
  };

  const handleDeleteClick = (id) => {
    setSelectedDocId(id);
    setShowDeletePopup(true);
  };

  const handleConfirmDelete = () => {
    if (selectedDocId) {
      DeleteTranslation(selectedDocId);
    }
  };

  const handleCancelDelete = () => {
    setShowDeletePopup(false);
    setSelectedDocId(null);
  };

  useEffect(() => {
    getProofreadingData();
  }, [])

  return (
    <div className="proofreading-container">
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <h2 style={{ fontWeight: '400', width: '20%', marginTop: '10px' }} >Proofreading Management</h2>

      </div>

      <div>

        {data.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: '40px',
            margin: '40px 0',
            color: '#666',
            fontSize: '18px',
          }}>
            No requests found ...
          </div>
        ) : (
          <>
            {data.map((taskDetails, index) => (
              <>

                <div key={taskDetails.id || index}>
                  <div
                    onClick={() => getDocByRequestID(taskDetails.id, true)}
                    className="task-row"
                    style={{
                      cursor: 'pointer',
                      margin: '30px 0px',
                      padding: '10px 30px',
                      borderRadius: '12px',
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: '10px',
                      border: '1px solid #000'
                    }}
                  >

                    <div style={{ flex: '1 1 50px', minWidth: '50px' }}>
                      <strong style={{ fontSize: '14px', fontWeight: '500' }}>Client</strong>
                      <br />
                      {taskDetails?.clientName ? taskDetails?.clientName : 'N/A'}
                    </div>
                    <div style={{ flex: '1 1 50px', minWidth: '50px' }}>
                      <strong style={{ fontSize: '14px', fontWeight: '500' }}>Request Date</strong>
                      <br />
                      {taskDetails.requestDate ? taskDetails.requestDate.substring(0, 10) : 'N/A'}
                    </div>
                    <div style={{ flex: '1 1 50px', minWidth: '50px' }}>
                      <strong style={{ fontSize: '14px', fontWeight: '500' }}>Task title</strong>
                      <br />
                      {taskDetails.taskTitle ? taskDetails?.taskTitle : 'N/A'}
                    </div>



                    <div style={{ flex: '1 1 50px', minWidth: '50px' }}>
                      <strong style={{ fontSize: '14px', fontWeight: '500' }}>Total Pages</strong>
                      <br />
                      {taskDetails.totalPages ? taskDetails.totalPages : 'N/A'}
                    </div>

                    <div style={{ flex: '1 1 50px', minWidth: '50px' }}>
                      <strong style={{ fontSize: '14px', fontWeight: '500' }}>Proofreader</strong>
                      <br />
                      {taskDetails.proofreaderName ? taskDetails.proofreaderName : 'N/A'}
                    </div>
                    <div style={{ flex: '1 1 50px', minWidth: '50px' }}>
                      <strong style={{ fontSize: '14px', fontWeight: '500' }}>Delivery Date</strong>
                      <br />
                      {taskDetails.deliveryDate ? taskDetails.deliveryDate.substring(0, 10) : 'N/A'}
                    </div>
                    <div style={{ flex: '1 1 50px', minWidth: '50px' }}>
                      <strong style={{ fontSize: '14px', fontWeight: '500' }}>Status</strong>
                      <br />
                      <span
                        style={{ padding: '6px 16px', borderRadius: '20px', fontWeight: '500', fontSize: '14px', color: "#000", backgroundColor: "#B991FF" }}

                        className="status">
                        {taskDetails.status}
                      </span>
                    </div>

                  </div>
                  {currentOpenRequestId === taskDetails.id && openRequests[taskDetails.id] && (
                    <>

                      {taskDetails.mistakesDocumentUrl ? <>
                        <div className="custom-select" style={{ display: 'flex', width: '300px', alignItems: 'center', justifyContent: 'space-between' }}>

                          <a
                            onClick={() => { handleDownload(taskDetails.mistakesDocumentId, taskDetails.mistakesDocumentUrl) }}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                          >
                            {taskDetails?.mistakesDocumentUrl.split('.com/')[1]};
                          </a>
                          <DeleteIcon
                            onClick={() => deleteMistakesDocs(taskDetails.id)}
                            style={{ fontSize: '18px', color: 'red', cursor: 'pointer' }}
                          />
                        </div>

                      </> : <>
                        <div
                          className="select-wrapper"
                          style={{ marginTop: '15px', cursor: 'pointer' }}
                          onClick={() => fileInputRef.current?.click()}
                        >
                          <p className="custom-select">Mistakes (Word)</p>
                          <DownloadIcon className="arrow-icon" style={{ fontSize: '16px' }} />
                          <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: 'none' }}
                            onChange={(e) => handleUploadMisTakes(e, requeestID)}
                            accept="*/*"
                          />
                        </div>

                      </>}


                      <table className="styled-table" style={{ marginTop: "10px", width: "100%" }}>
                        <thead className="styled-thead">
                          <tr>
                            <th style={{ fontWeight: '500', color: "#000", fontSize: '14px' }}>Document (PDF)</th>
                            <th style={{ fontWeight: '500', color: "#000", fontSize: '14px' }}>Template (Word)</th>
                            <th style={{ fontWeight: '500', color: "#000", fontSize: '14px' }}>Translation (Word)</th>
                            <th style={{ fontWeight: '500', color: "#000", fontSize: '14px' }}>Created At</th>
                          </tr>
                        </thead>
                        <tbody className="styled-tbody">
                          {openRequests[taskDetails.id].map((row, idx) => (
                            <tr className="styled-row" key={`${taskDetails.id}-${idx}`}>

                              <td className="styled-cell">
                                <a
                                  onClick={() => { handleDownload(row.documentId, row.document) }}
                                  style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {row?.document.split('.com/')[1]};
                                </a>
                              </td>

                              <td className="styled-cell">
                                <input
                                  type="file"
                                  onClick={() => { handleDownload(row.id) }}
                                  style={{ display: 'none' }}
                                  onChange={(e) => { handleFileChange(e, row.id) }}
                                  accept="*/*"
                                />

                                {row.templateUrl ? (
                                  <a
                                    onClick={() => { handleDownload(row.templateId, row.templateUrl) }}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                                  >
                                    {row?.templateUrl.split('.com/')[1]};
                                  </a>
                                ) : (
                                  !selectedFiles[row.id] && (
                                    'no file uploaded'
                                  )
                                )}
                              </td>

                              <td className="styled-cell">
                                <input
                                  type="file"
                                  ref={el => fileInputRefs.current[row.id] = el}
                                  style={{ display: 'none' }}
                                  onChange={(e) => { handleFileChange(e, row.id) }}
                                  accept="*/*"
                                />

                                {uploadingRows[row.id] ? (
                                  <CircularProgress size={16} style={{ color: "#1976d2" }} />
                                ) : row.translatedDocumentUrl ? (
                                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <a
                                      onClick={() => { handleDownload(row.translatedDocumentId, row.translatedDocumentUrl) }}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                                    >
                                      {row?.translatedDocumentUrl.split('.com/')[1]};
                                    </a>

                                    <DeleteIcon
                                      onClick={() => handleDeleteClick(row.id)}
                                      style={{ fontSize: '18px', color: 'red', cursor: 'pointer' }}
                                    />
                                  </div>
                                ) : 
                                   (
                                    <FileUploadIcon
                                      style={{ fontSize: "16px", cursor: "pointer" }}
                                      onClick={() => { handleIconClick(row.id) }}
                                    />
                                  )}
                              </td>

                              <td className="styled-cell">
                                {row?.creationDate?.substring(0, 10) || "—"}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>


                      <div style={{ display: "flex", justifyContent: "end" }}>
                        <button
                          onClick={handleNextClick}
                          style={{
                            marginTop: '10px',
                            fontSize: '14px',
                            backgroundColor: "transparent",
                            padding: "5px 25px",
                            border: "1px solid #000",
                            cursor: "pointer",
                            borderRadius: "3px",
                          }}
                        >
                          NEXT
                        </button>
                      </div>

                    </>
                  )}
                </div>
              </>
            ))}


          </>


        )}
        {errorMessage && <>
          <div style={{ backgroundColor: 'red' }} className="popup-message">
            {errorMessage}
          </div>
        </>}


        {successfulMessage && <>
          <div className="popup-message">
            {successfulMessage}
          </div>
        </>}



        {uploadMessage && <>
          <div className="popup-message">
            {uploadMessage}
          </div>
        </>}


        {showDeletePopup && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999
          }}>
            <div style={{
              backgroundColor: 'white',
              padding: '30px',
              borderRadius: '8px',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              maxWidth: '400px',
              width: '90%'
            }}>
              <h3 style={{ margin: '0 0 20px 0', fontSize: '18px', fontWeight: '600' }}>
                Confirm Delete
              </h3>
              <p style={{ margin: '0 0 30px 0', color: '#666' }}>
                Are you sure you want to delete this document?
              </p>
              <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                <button
                  onClick={handleCancelDelete}
                  style={{
                    padding: '10px 20px',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    backgroundColor: 'white',
                    cursor: 'pointer',
                    fontSize: '14px'
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleConfirmDelete}
                  style={{
                    padding: '10px 20px',
                    border: 'none',
                    borderRadius: '4px',
                    backgroundColor: 'red',
                    color: 'white',
                    cursor: 'pointer',
                    fontSize: '14px'
                  }}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )}

        {renderConfirmationPopup()}
      </div>
    </div>
  );
};


const styles = {
  taskRow: {
    cursor: "pointer",
    margin: "30px 0px",
    padding: "10px 30px",
    borderRadius: "12px",
    display: 'flex',
    flexWrap: 'wrap',
    border: "1px solid #000",
  },
  tableHeader: {
    fontWeight: '500',
    color: "#000",
    fontSize: '14px'
  },
  link: {
    color: "blue",
    textDecoration: "underline",
    cursor: "pointer"
  },
  nextButton: {
    marginTop: '10px',
    fontSize: '14px',
    backgroundColor: "transparent",
    padding: "5px 25px",
    border: "1px solid #000",
    cursor: "pointer",
    borderRadius: "3px",
  },
  statusBadge: {
    padding: '6px 16px',
    borderRadius: '20px',
    fontSize: '14px',
    fontWeight: '500'
  },
  popupOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999
  },
  popupContent: {
    backgroundColor: 'white',
    padding: '30px',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    maxWidth: '400px',
    width: '90%'
  },
  popupTitle: {
    margin: '0 0 20px 0',
    fontSize: '18px',
    textAlign: 'center',
    color: '#333'
  },
  popupButtons: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'center'
  },
  cancelButton: {
    padding: '8px 20px',
    backgroundColor: '#f5f5f5',
    border: '1px solid #ddd',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px'
  },
  confirmButton: {
    padding: '8px 20px',
    backgroundColor: '#3F302E',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px'
  }
};

export default Proofreading;